/* ----------------------------------------------
    Javascript code to get the bundle products and show them on the productpage
------------------------------------------------ */

import { createLoader, removeLoader, createIconLoader } from 'helpers/loader/loader';
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';
import axios from 'axios';
import debounce from 'helpers/debounce/debounce';
import formatPrice from 'helpers/format-price/formatPrice';
import { Modal } from 'components/modal/modal';

export default (function () {
    let addingBundleToCart = false; //Create global var if add to cart button is already clicked
    const bundleSettings = {}; //Create global object to save some settings related to the bundles
    let bundleMoved = false; //Create global var to check if bundle is already moved
    /*-----------------------------Init bundle------------------------------*/
    const initBundle = function () {
        bundleSettings.containerEl = document.getElementById('bundle-products'); //Get the bundle products container element
        //Check if bundle element exists
        if (bundleSettings.containerEl) {
            //Add base variables
            bundleSettings.mainProduct = document.getElementById('main-bundle-product').querySelector('.product-row'); //Main product, isn't part of bundle products
            bundleSettings.changeProduct = {}; //Set empty object to collect changeProduct information
            bundleSettings.selectedProducts = []; //Create empty array of selected products
            bundleSettings.url = bundleSettings.containerEl.getAttribute('data-url'); //Get url to do the ajax request and get the bundle products
            moveBundle(); //Move bundle
            createLoader(bundleSettings.containerEl); //Create loader icon
            //check if bundle url exists
            if (bundleSettings.url) {
                getBundle(); //Get bundle
            }
        }
    };

    /*-----------------------------Move bundle------------------------------*/
    const moveBundle = function () {
        let moveContainerEl; //Create moveContainer var

        if (!bundleMoved) {
            moveContainerEl = document.querySelector('.bundle-products');
            bundleMoved = true;
        }
        //Move the html when move container is set
        if (moveContainerEl) {
            const moveContainerChildEl = moveContainerEl.firstElementChild; //Get element to insert before
            moveContainerEl.insertBefore(bundleSettings.containerEl.parentElement.parentElement, moveContainerChildEl); //Move bundles before product info
        }
    };

    /*-----------------------------Get bundle data------------------------------*/
    const getBundle = function () {
        //Get bundle data
        axios
            .get(bundleSettings.url)
            .then((response) => {
                //Check if there is a response
                if (response) {
                    bundleSettings.containerEl.innerHTML = response.data; // Add products to element
                    bundleSettings.containerEl.parentElement.classList.add('visible'); //Add visible class to show the bundle

                    //Add google event if bundle is available on page or not.
                    const bundleType = document.getElementById('add-bundle-to-cart').getAttribute('data-bundle-type'); // Get bundle type to change events based on bundle type
                    const gtmLabel = document.getElementById('productpage').getAttribute('data-id');

                    if (gtmLabel) {
                        trackEvent(
                            'productactions',
                            bundleType === 'bundle' ? 'Own_Bundle: yes' : 'Recipe: yes',
                            gtmLabel,
                            1
                        );
                    }

                    addBundleEventListeners(); //Add event listeners
                } else {
                    bundleSettings.containerEl.parentElement.classList.add('d-none'); //Hide entire bundle when no data available
                }
            })
            .catch(() => {
                bundleSettings.containerEl.parentElement.classList.add('d-none'); //Hide entire bundle when request fails
            });
    };

    /*-----------------------------Loop over bundle products----------------------------*/
    const addBundleEventListeners = function () {
        //Add click event listener
        bundleSettings.containerEl.addEventListener('click', function (e) {
            //Get alternative products
            const changeBtn = e.target.closest('.change-bundle-product');
            const bundleType = document.getElementById('add-bundle-to-cart').getAttribute('data-bundle-type'); // Get bundle type to change events based on bundle type
            if (changeBtn) {
                getAlternativeProductData(changeBtn);

                trackEvent(
                    'productactions',
                    bundleType === 'bundle' ? 'change_own_bundle' : 'change_recipe',
                    bundleSettings.mainProduct.getAttribute('data-code')
                );
            }
            //Add to cart button
            if (e.target.closest('#add-bundle-to-cart')) {
                calculateBundlePrice();
                addBundleToCart(e.target.closest('#add-bundle-to-cart'));
                trackEvent(
                    'productactions',
                    bundleType === 'bundle' ? 'incart_own_bundle' : 'incart_recipe',
                    bundleSettings.mainProduct.getAttribute('data-code')
                );
            }
        });
        //Add change event listener
        bundleSettings.containerEl.addEventListener('change', function (e) {
            const checkbox = e.target.closest('.form-check-input'); //Check if checkbox is changed
            if (checkbox) {
                const productId = checkbox.closest('.product-row').getAttribute('data-id'); //Get the productId
                const checkboxState = checkbox.checked; //Check if checkbox is checked
                const action = checkboxState ? 'show' : 'hide'; //Create action show/hide

                //Enable or disable the product row when checked/unchecked
                if (checkboxState) {
                    checkbox.closest('.product-row').classList.remove('disabled');
                } else {
                    checkbox.closest('.product-row').classList.add('disabled');
                }
                updateRelatedProducts(productId, action); //Update related products

                calculateBundlePrice(); //Calculate bundle price
            }
        });
        //Add resize event listener
        window.addEventListener(
            'resize',
            debounce(function () {
                moveBundle(); //Move bundle to the correct position
            }, 100)
        );
    };

    /*-----------------------------Alternative products---------------------------*/
    const getAlternativeProductData = function (changeBtn) {
        const popupId = changeBtn.getAttribute('data-popup'); //Get the popupId
        const url = changeBtn.getAttribute('data-url'); //Get the ajax request url
        const currentProductRow = changeBtn.parentElement.parentElement.parentElement.parentElement; //Select the
        // current product-row
        bundleSettings.changeProduct.replaceContainerEl = currentProductRow.parentElement; //Set the replaceContainer element we will use the add a new product to if changed.
        bundleSettings.changeProduct.changeBtn = changeBtn; //Save the change button
        bundleSettings.changeProduct.currentProductId = currentProductRow.getAttribute('data-id'); //Get the current product id

        //Get change product data
        if (popupId) {
            //Open the alternatives popup if it's opened before by using the data-popup set on the edit button
            openAlternativesPopup(popupId);
        } else {
            //Get the alternatives with AJAX
            axios.get(url).then((response) => {
                //Check if there is a response
                if (response) {
                    const popupHolder = document.createElement('div'); //Create a popup holder, so we can add the response HTML and select item from that.
                    popupHolder.classList.add('popup-holder'); //Add a class to the popup holder
                    popupHolder.innerHTML = response.data; //Add the response HTML to the holder
                    const popup = popupHolder.querySelector('.bundle-alternatives-popup'); //Select the popup from the ajax repsonse
                    const popupId = 'popup-' + bundleSettings.changeProduct.currentProductId; //Create the popupID
                    popup.setAttribute('id', popupId); //Set an unique id of the popup
                    bundleSettings.containerEl.parentElement.appendChild(popup); //Add the popup to the bundle section element
                    bundleSettings.changeProduct.changeBtn.setAttribute('data-popup', '#' + popupId); //Set the id of the newly created popup to the change button, so we can use that to reopen the popup again without the AJAX request.

                    openAlternativesPopup('#' + popupId); //Open the popup with alternatives
                }
            });
        }
    };

    const openAlternativesPopup = function (popupId) {
        const alternativeProducts = document.querySelector(popupId); //HTML for the popup which contains all the alternative products
        const changeProduct = bundleSettings.changeProduct; //The product which will be changed
        const selectedProduct = alternativeProducts.querySelector('.product-row.selected');
        if (selectedProduct) {
            selectedProduct.classList.remove('selected');
        }

        const currentProduct = alternativeProducts.querySelector(
            '.product-row[data-id="' + changeProduct.currentProductId + '"]'
        ); //Select the current product
        currentProduct.classList.add('selected'); //Add selected class to current product

        const alternativesPopup = new Modal({
            selector: popupId,
            isClosable: true
        });

        alternativesPopup.show();

        //Add event listeners
        const alternativePopup = document.querySelector(popupId);
        alternativePopup.addEventListener('click', (e) => {
            changeProducts(e, alternativesPopup);
        }); //Bind change products event
    };

    /*-----------------------------Update related products---------------------------*/
    const updateRelatedProducts = function (productId, action) {
        const relatedProducts = bundleSettings.containerEl.querySelectorAll(
            '.product-row[data-related-to="' + productId + '"]'
        );
        //Loop over all the related products
        if (relatedProducts) {
            for (let i = 0; i < relatedProducts.length; ++i) {
                const productId = relatedProducts[i].getAttribute('data-id'); //Get the productid to check if there are any other related products
                //Hide/show or remove the product
                switch (action) {
                    case 'hide':
                        //Hide the related products when product is unchecked
                        relatedProducts[i].style.display = 'none';
                        relatedProducts[i].querySelector('.form-check-input').checked = false; //uncheck the related products
                        break;
                    case 'show':
                        //Show the related products when product is checked
                        relatedProducts[i].removeAttribute('style');
                        relatedProducts[i].querySelector('.form-check-input').checked = true; //Recheck the related products
                        break;
                    case 'remove':
                        relatedProducts[i].remove(); //Remove the products when product is changed
                        break;
                    default:
                        break;
                }

                //Call the update function again with the new id
                updateRelatedProducts(productId, action);
            }
        }
    };

    /*-----------------------------Get related products---------------------------*/
    const getRelatedProducts = function (url) {
        createLoader(bundleSettings.containerEl);
        axios
            .get(url)
            .then((response) => {
                //Check if there is a response
                if (response) {
                    const productToPlaceAfter = bundleSettings.changeProduct.replaceContainerEl.parentElement; //Get "parent" product
                    productToPlaceAfter.insertAdjacentHTML('afterend', response.data); //Insert products after the "parent" product
                    removeLoader(bundleSettings.containerEl); //Remove loader icon
                    calculateBundlePrice(); //Recalculate the total price
                }
            })
            .catch(() => {
                //Do something when failed
                removeLoader(bundleSettings.containerEl); //Remove loader icon
            });
    };

    /*-----------------------------Calculate bundle price---------------------------*/
    const changeProducts = function (e, popup) {
        const selectBtn = e.target.closest('.select-new-product');
        if (selectBtn) {
            const changeProduct = bundleSettings.changeProduct; //Get the current product in the bundle which needs to be changed
            const newProduct = selectBtn.parentElement.parentElement.parentElement.cloneNode(true); //Get the new products from the alternatives and clone the HTML
            const newProductId = newProduct.getAttribute('data-id'); //Get the product id
            const bundleType = document.getElementById('add-bundle-to-cart').getAttribute('data-bundle-type'); // Get bundle type to change events based on bundle type

            //Check if the new product isn't the same as the current product
            if (newProductId !== changeProduct.currentProductId) {
                newProduct.querySelector('.select-new-product').remove(); //Remove the select button
                newProduct.querySelector('.selected-product').remove(); //Remove selected state button
                newProduct.querySelector('.checkbox').style.display = 'block'; //Show checkbox again
                newProduct.querySelector('.product-info').appendChild(changeProduct.changeBtn); //Add change button
                // to new products
                changeProduct.replaceContainerEl.innerHTML = ''; //Clear the HTML where the product needs to be placed
                changeProduct.replaceContainerEl.appendChild(newProduct); //Add the new product to the HTML
                popup.hide(); //Close the popup
                updateRelatedProducts(changeProduct.currentProductId, 'remove'); //Update the related products

                if (newProduct.hasAttribute('data-related-url')) {
                    getRelatedProducts(newProduct.getAttribute('data-related-url')); //Get new related products
                } else {
                    calculateBundlePrice(); //Calculate price
                }
            }

            //Add google event
            trackEvent(
                'productactions',
                bundleType === 'bundle' ? 'change_own_bundle_product' : 'change_recipe_product',
                changeProduct.currentProductId + ' -> ' + newProductId
            );
        }
    };

    /*-----------------------------Calculate bundle price---------------------------*/
    const calculateBundlePrice = function () {
        const bundleProducts = bundleSettings.containerEl.querySelectorAll('.product-row'); //Get all bundle products
        const bundleTotalPriceData = bundleSettings.mainProduct.getAttribute('data-price').replace(/\./g, '');
        let bundleTotalPrice = parseFloat(bundleTotalPriceData.replace(',', '.')); //Set bundle total price to 0
        const bundleTotalPriceEl = bundleSettings.containerEl.parentElement.querySelector('#bundle-total-price'); //Select total price element
        bundleSettings.selectedProducts = []; //Clear selected bundle array

        //Loop through all bundle products
        for (let i = 0; i < bundleProducts.length; i++) {
            const productPrice = bundleProducts[i].getAttribute('data-price'); //Get bundle product price
            const checked = bundleProducts[i].querySelector('input[type="checkbox"]').checked; //Check if product is checked

            //Collect product data to generate array of selected products
            const productId = bundleProducts[i].getAttribute('data-id'); //Get the product id
            const productQuantity = bundleProducts[i].getAttribute('data-quantity'); //Get the quantity
            const bundleId = bundleProducts[i].getAttribute('data-bundle-id'); //Get the bundle id

            //Check if productprice is set and the product is checked
            if (productPrice && checked) {
                bundleTotalPrice += parseFloat(productPrice); //Add price to bundle total price
                //Create array of selected products
                bundleSettings.selectedProducts.push({
                    productId: productId,
                    quantity: productQuantity,
                    bundleId: bundleId
                });
            }
        }
        bundleTotalPriceEl.innerHTML = formatPrice(bundleTotalPrice); //Set bundle price
    };

    /*----------------CREATE FORM AND SUBMIT PRODUCTS TO ADD TO CART ----------------*/
    const addBundleToCart = function (cartBtn) {
        //Check if the add to cart button isn't already clicked
        if (!addingBundleToCart) {
            addingBundleToCart = true; //Set to true because the add to cart button is clicked.
            createIconLoader(cartBtn); //Show loader in cart button
            const products = bundleSettings.selectedProducts; //Get all the selected products
            const url = cartBtn.getAttribute('data-url'); //Get the url to post the form to
            const returnUrl = cartBtn.getAttribute('data-return-url'); //Get the redirect url
            const bundleType = document.getElementById('add-bundle-to-cart').getAttribute('data-bundle-type'); // Get bundle type to change events based on bundle type
            const bundleId = cartBtn.getAttribute('data-bundle-id'); //Get the bundle id
            let form = document.getElementById('add-bundle-form'); //Get the form

            //Create form and set form attributes
            if (form) {
                form.innerHTML = ''; //Check if form element already exist. If so, delete inner html.
            } else {
                form = document.createElement('form'); //Create the form element
                form.setAttribute('id', 'add-bundle-form'); //Set the id
                form.setAttribute('method', 'POST'); //Add the method
                form.setAttribute('action', url); //Add action
            }
            //Create return url input field
            form.appendChild(createFormField('hidden', 'return_url', returnUrl));

            /* Only create form when there are products selected */
            if (products.length > 0) {
                //Create main product input field
                form.appendChild(createFormField('hidden', 'productid[]', bundleId));
                form.appendChild(createFormField('hidden', 'aantal[]', 1));

                //Create fields for recipe bundle type
                if (bundleType === 'recipe') {
                    //Create input fields per selected bundle products
                    for (let i = 0; i < products.length; ++i) {
                        form.appendChild(createFormField('hidden', 'productid[]', products[i].productId));
                        form.appendChild(createFormField('hidden', 'aantal[]', products[i].quantity));
                    }
                }

                //Create fields for bundle bundle type
                if (bundleType === 'bundle') {
                    //Add the main product as bundle product
                    const mainProductBundleId = cartBtn.getAttribute('data-product-bundle-id');
                    const mainProductId = bundleSettings.mainProduct.getAttribute('data-id');
                    form.appendChild(
                        createFormField('hidden', 'selection[' + mainProductBundleId + ']', mainProductId)
                    );

                    //Create input fields per selected bundle products
                    for (let i = 0; i < products.length; ++i) {
                        form.appendChild(
                            createFormField('hidden', 'selection[' + products[i].bundleId + ']', products[i].productId)
                        );
                    }
                }
            } else {
                //If no bundle product is selected, submit only the main product
                const mainProductId = bundleSettings.mainProduct.getAttribute('data-id');
                form.appendChild(createFormField('hidden', 'productid', mainProductId));
                form.appendChild(createFormField('hidden', 'aantal[]', 1));
            }
            //Add form to page and submit the form
            if (form.innerHTML) {
                bundleSettings.containerEl.appendChild(form);
                form.submit();
            }
        }
    };

    /*-------------------------Create form field----------------*/
    const createFormField = function (type, name, value) {
        const inputField = document.createElement('input');
        inputField.setAttribute('type', type);
        inputField.setAttribute('name', name);
        inputField.setAttribute('value', value);

        return inputField;
    };

    /*-----------------------------Public methods------------------------------*/
    return {
        init: initBundle,
        moveBundle: moveBundle
    };
})();
